export enum TripActivityType {
  // start = 1,
  hookUp = 2,
  pickUp = 3,
  delivery = 4,
  drop = 5,
  // switch = 6,
  wayPoint = 7
}
